import React, { useContext, useCallback } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

// Components
import { ClickableTile, Text } from '../../../../../../components'

// Helpers
import { formatToCurrency } from '../../../../../../helpers'

// Context
import { OverlayContext } from '../../../../../../contexts'

// Constants
import { PANEL_IDS } from '../../../../../../constants/overlayPanels'

import styles from '../base.module.scss'

const SubTitle = ({ budgetDiff }) => {
  const text = budgetDiff >= 0 ? 'over' : 'under'

  return (
    <>
      <Text size='s'>
        which is{' '}
        <Text element='span' weight='semibold'>
          {formatToCurrency(Math.abs(Math.round(budgetDiff)))}
        </Text>
      </Text>
      <Text size='s'>{text} your budget</Text>
    </>
  )
}

const MonthlyCostTile = ({ className, budgetDiff, monthlyCost }) => {
  const { handleAddOverlay } = useContext(OverlayContext)
  const color = budgetDiff >= 0 ? 'red' : 'green'

  const subTitleComponent = useCallback(
    () => <SubTitle budgetDiff={budgetDiff} />,
    [budgetDiff]
  )

  return (
    <ClickableTile
      className={classnames(styles.tile, className)}
      heading='you might pay'
      controlledColor={color}
      value={monthlyCost ? monthlyCost : 0}
      suffix={monthlyCost ? '/mo' : ''}
      formatter={formatToCurrency}
      subTitleComponent={subTitleComponent}
      onClick={() => handleAddOverlay(PANEL_IDS.MONTHLY_COST)}
    />
  )
}

SubTitle.propTypes = {
  budgetDiff: PropTypes.number,
}

MonthlyCostTile.propTypes = {
  className: PropTypes.string,
  budgetDiff: PropTypes.number,
  monthlyCost: PropTypes.number,
}

export default MonthlyCostTile
